import { PurchaseData } from 'storage/types';

export const PURCHASE_STORAGE_KEY = 'purchase';

const isPurchaseData = (value: unknown): value is PurchaseData => {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as Partial<PurchaseData>;
  return (
    typeof candidate.date === 'string' &&
    Array.isArray(candidate.packs) &&
    Array.isArray(candidate.entrances)
  );
};

// A cart written before a shape change is discarded rather than half-read.
export const readStoredPurchase = (): PurchaseData | null => {
  try {
    const raw = sessionStorage.getItem(PURCHASE_STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return isPurchaseData(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const writeStoredPurchase = (purchase: PurchaseData): void => {
  sessionStorage.setItem(PURCHASE_STORAGE_KEY, JSON.stringify(purchase));
};
